import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListAtasAud from '../../../components/saude/documentos/atasaudiencia';


function ListAtasAudScreen() {
    return (
        <Fragment>
            <Head titulo="Atas de Audiências Públicas de Prestação de Contas" />
            <Header />
            <Container>
               <ListAtasAud /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListAtasAudScreen;